import { isSSR } from '@front10/utils';
import type { default as moment } from 'moment';

export function UNSAFE_getMoment(): typeof moment | undefined {
  if (isSSR()) {
    return;
  }
  return window?.EM?.___fcRuntime?.vendors?.moment;
}
